// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1__c6e8dc25986e38cf3cea","cls2":"News-cls2__bccde6f5d27109fbfb52 News-cls1__c6e8dc25986e38cf3cea"};